export async function initSplitText() {
  const splitText = window.Splitting;

  if (!splitText) return null;

  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }

  document.querySelectorAll("[data-scroll-animation-reveal='chars']").forEach((el) => {
    if (!el.hasAttribute("data-split")) el.setAttribute("data-split", "chars");
  });

  const targets = document.querySelectorAll("[data-split]");
  if (!targets.length) return null;

  const result = [];
  targets.forEach((target) => {
    const by = target.dataset.split || "words";
    result.push(
      splitText({
        target,
        by
      })
    );
  });

  return result;
}
